import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Input, Toast } from "../ui";
import { useAuth } from "./AuthContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setSubmitting(true);
    try {
      await register({
        email,
        password,
        firstName,
        lastName,
        organizationName: organizationName.trim() || undefined,
      });
      setSuccess("Cuenta creada. Ya puedes iniciar sesión.");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.Message || "No se pudo registrar.";
      setError(typeof msg === "string" ? msg : "Error al registrar");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-cream via-white to-cream-deep px-4 py-12">
      <div className="pointer-events-none absolute inset-0 bg-noise opacity-30 mix-blend-multiply" aria-hidden />
      <div className="relative z-10 mx-auto flex min-h-[80vh] w-full max-w-md items-center">
        <Card className="w-full overflow-hidden">
          <div className="h-1 bg-gradient-to-r from-gold via-gold-bright to-arena-bright" />
          <CardHeader className="pb-1 pt-6">
            <h1 className="font-display text-3xl font-extrabold text-ink">Crear cuenta</h1>
            <p className="mt-1 text-sm text-ink-muted">Registra tu perfil para gestionar torneos y favoritos.</p>
          </CardHeader>
          <CardBody className="pb-6">
            {error ? <Toast kind="error" className="mb-4">{error}</Toast> : null}
            {success ? <Toast kind="success" className="mb-4">{success}</Toast> : null}
            <form onSubmit={handleSubmit} className="space-y-3">
              <Input label="Nombre" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
              <Input label="Apellidos" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
              <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              <Input
                label="Contraseña"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                helperText="Mínimo 8 caracteres"
                required
              />
              <Input
                label="Nombre de organización (opcional)"
                value={organizationName}
                onChange={(e) => setOrganizationName(e.target.value)}
              />
              <Button type="submit" variant="gold" size="lg" className="mt-3 w-full">
                {submitting ? "Registrando..." : "Registrarse"}
              </Button>
            </form>
            <p className="mt-4 text-sm">
              <RouterLink to="/login" className="font-semibold text-arena-bright hover:underline">
                Ya tengo cuenta
              </RouterLink>
            </p>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
